var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: _vm.name, params: {id: _vm.id} }},nativeOn:{"click":function($event){$event.preventDefault();return _vm.linkSelect({ name: _vm.name, params: {id: _vm.id} })}}},[_c('div',[_c('div',{staticClass:"icon_menu"},[_c('i',{class:['sherpa-icon', 'icon-'+_vm.name]})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ec9b61d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/detail/flap.vue
// module id = 98FQ
// module chunks = 1